import { WebUserService } from './web';
export default WebUserService;
